import { Suspense } from 'react'
import { Link } from 'react-router'
import { FormattedMessage } from 'react-intl'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import TableSkeleton from '@components/skeletons/TableSkeleton/TableSkeleton'
import DataSetAboutSkeleton from '@components/skeletons/DataSetAboutSkeleton/DataSetAboutSkeleton'
import type { DataItemPayload } from 'src/types/global'
import SampleData from '@components/SampleData/SampleData'
import DataSetAbout from '@components/DataSetAbout/DataSetAbout'
import ErrorDatasetInfo from '@components/ErrorBoundary/ErrorDatasetInfo/ErrorDatasetInfo'
import EmptyChartState from '@components/GridLayout/WidgetView/EmptyChartState/EmptyChartState'

import './DataSetInfo.css'

interface Props {
  selectedItem: DataItemPayload | undefined
  onClear: () => void
}

export default function DataSetInfo({ selectedItem, onClear }: Props) {
  if (!selectedItem) return null

  return (
    <>
      <div id="data-set-info">
        <header>
          <h1>
            <span className="icon icon-table" />
            <span>{selectedItem.name}</span>
          </h1>
          <div className="buttons">
            <Link
              to={`/data-sets/${selectedItem.id}`}
              className="button highlight-button"
            >
              <span className="icon icon-select" />
              <span>
                <FormattedMessage id="dataset.open.text" />
              </span>
            </Link>
            <button onClick={onClear}>
              <span className="icon icon-cross" />
              <span>
                <FormattedMessage id="cancel" />
              </span>
            </button>
          </div>
        </header>
        <ErrorBoundary
          errorComponent={ErrorDatasetInfo}
          key={`about-${selectedItem.id}`}
        >
          <Suspense fallback={<DataSetAboutSkeleton />}>
            <DataSetAbout id={selectedItem.id} />
          </Suspense>
        </ErrorBoundary>
      </div>
      <ErrorBoundary
        errorComponent={EmptyChartState}
        key={`sample-${selectedItem.id}`}
      >
        <Suspense fallback={<TableSkeleton />}>
          <SampleData id={selectedItem.id} />
        </Suspense>
      </ErrorBoundary>
    </>
  )
}
